<template>
  <div
    class="community-header"
  >
    <div :class="imageBoxClasses">
      <picture>
        <source
          type="image/webp"
          :srcset="toWebp(imageSrc)"
        >
        <img
          :src="imageSrc"
          alt=""
          class="community-header__image"
          data-test-id="community-header-image"
          @error="handleErrorOnImageSource"
        >
      </picture>
    </div>
    <div class="community-header__text">
      <h1
        class="community-header__heading"
        data-test-id="community-header-heading"
      >Community Hub</h1>
      <p
        v-if="userIsLoggedIn"
        class="community-header__greeting"
        data-test-id="community-header-greeting"
      >
        Welcome back,
        <router-link
          :to="{ name: 'userProfileOverview' }"
          class="community-header__profile-link"
        >
          {{ currentUser.username }}</router-link>!
      </p>
      <p
        v-else
        class="community-header__greeting"
        data-test-id="community-header-greeting"
      >
        {{ headerGreetingText }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toWebp, handleErrorOnImageSource } from '@/utils/utils';

export default {
  name: 'CommunityHeader',
  computed: {
    ...mapGetters(['currentUser', 'userIsLoggedIn']),
    imageSrc() {
      if (this.userIsLoggedIn) {
        return '/common/nexus/community-header-loggedin.png';
      }
      return '/common/nexus/community-header-loggedout.png';
    },
    imageBoxClasses() {
      const classes = ['community-header__image-box'];
      if (this.userIsLoggedIn) {
        classes.push('community-header__image-box--loggedin');
      }
      return classes;
    },
    headerGreetingText() {
      if (this.$site.settings.community_hub && this.$site.settings.community_hub.header_greeting) {
        return this.$site.settings.community_hub.header_greeting;
      }
      if (this.$site.settings.condition_name) {
        return `Check out the latest updates from our community of members living with ${this.$site.settings.condition_name}.`;
      }
      return '';
    },
  },
  methods: {
    toWebp,
    handleErrorOnImageSource,
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_community-header';
</style>
